module.exports = __webpack_public_path__ + "static/media/business.2e78b06a.png";